<template>
  <div class="enterpriseProject">
    <el-card class="box-card">
      <div slot="header" class="clearfix flexLr">
        <!-- 标题 -->
        <span style="font-size: 24px;width:50%">{{ $t('工单任务.工单任务') }}</span>
        <div class="head-text flexLr" style="width:50%;justify-content: right;">
          <div style="margin-right: 5px;">
            <el-input v-model="cxorderText" :placeholder="$t('工单任务.请输入任务名称')" @change="cxorder"
              class="search-input"></el-input>
            <el-button slot="append" icon="el-icon-search"></el-button>
          </div>

          <el-button style="margin-right: 10px;" :type="pitch == 1 ? 'warning' : 'primary'" @click="regionUpdate(1)">{{ $t('工单任务.我发起的')
          }}</el-button>

          <el-badge style="margin-right: 10px;"  :value="lengths2">
            <el-button :type="pitch == 2 ? 'warning' : 'primary'" @click="regionUpdate(2)">{{ $t('工单任务.我执行的')
            }}</el-button>
          </el-badge>

          <el-badge style="margin-right: 10px;"  :value="lengths3">
            <el-button :type="pitch == 3 ? 'warning' : 'primary'" @click="regionUpdate(3)">{{ $t('工单任务.我审批的')
            }}</el-button>
          </el-badge>
          <el-button type="primary" plain @click="addTask" v-if="
            ($store.state.permissions != null &&
              $store.state.permissions.includes('1022')) ||
            $store.state.isProject
          ">{{ $t('工单任务.发起任务') }}</el-button>
        </div>
      </div>
      <el-container>
        <el-main>
          <div class="rygl-table">
            <el-table class="margin-20 table" v-loading="loading" :data="workOrder" :row-class-name="tableRowClassIndex"
              height="72vh" style="width: 98%; margin-left: 20px">
              <el-table-column align="center" type="selection" width="55"></el-table-column>
              <el-table-column align="center" type="index" :label="$t('工单任务.序号')" width="80"></el-table-column>
              <el-table-column align="center" prop="wkod02" :label="$t('工单任务.任务名称')">
                <template slot-scope="scope">
                  <el-button :title="scope.row.wkod02" @click="seeInfo(scope.row)" :style="{
                    width: '100%',
                    color: scope.row.Fuck ? 'red' : '#409EFF',
                  }">{{
                    scope.row.wkod02.length > 6
                      ? scope.row.wkod02.substr(0, 6) + "..."
                      : scope.row.wkod02
                  }}</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="wkod11Name" :label="$t('工单任务.发起人')"></el-table-column>
              <el-table-column align="center" prop="wkod05" :label="$t('工单任务.计划完成时间')"></el-table-column>
              <el-table-column align="center" prop="wkod19Name" :label="$t('工单任务.执行人')"></el-table-column>
              <el-table-column align="center" prop="wkod09" :label="$t('工单任务.验收截止时间')"></el-table-column>
              <el-table-column align="center" prop="wkod08Name" :label="$t('工单任务.验收人')"></el-table-column>
              <el-table-column align="center" prop="wkod18" :label="$t('工单任务.进度')">
                <template slot-scope="scope">
                  <el-progress :percentage="scope.row.wkod18 == null ? 0 : scope.row.wkod18
                    " :format="format"></el-progress>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="state" :label="$t('工单任务.状态')">
                <template slot-scope="scope">
                  <p :style="'color:' +
                    (scope.row.state == '未启动延误' ||
                      scope.row.state == '进行中超时' ||
                      scope.row.state == '验收超时' ||
                      scope.row.state == '验收未通过'
                      ? 'red'
                      : scope.row.state == '提前完成待验收' ||
                        scope.row.state == '提前验收通过' ||
                        scope.row.state == '验收通过'
                        ? '#4caf50'
                        : scope.row.state == '未通过验收'
                          ? '#e71e63'
                          : '')
                    ">
                    {{ scope.row.state }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="exam" :label="$t('工单任务.标签')">
                <template slot-scope="scope">
                  <el-tag>{{ scope.row.wkod12 }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="exam" width="180" :label="$t('工单任务.操作')">
                <template slot-scope="scope">
                  <div>
                    <div v-show="region == 1">
                      <el-button type="primary" size="small" plain v-show="scope.row.state == '验收超时' ||
                        scope.row.state == '未启动延误' ||
                        scope.row.state == '进行中超时'
                        ? true
                        : false
                        " @click="press(scope.row, 2)">{{ $t('工单任务.催办') }}</el-button>
                      <el-button type="danger" size="small" plain @click="removeOrder(scope.row)">{{ $t('工单任务.删除')
                      }}</el-button>
                    </div>
                    <div v-show="region == 2">
                      <el-button type="primary" size="small" plain v-show="scope.row.state == '提前完成待验收' ||
                        scope.row.state == '验收超时'
                        ? true
                        : false
                        " @click="executeStartBtn(scope.row)" style="margin-left: 10px">{{ $t('工单任务.催办') }}</el-button>
                      <el-button type="primary" size="small" plain v-show="scope.row.state == '未启动延误' ||
                        scope.row.state == '待启动'
                        ? true
                        : false
                        " @click="startBtn(scope.row, 1)">{{ $t('工单任务.启动') }}</el-button>
                      <el-button type="primary" size="small" plain v-show="scope.row.state == '进行中' ||
                        scope.row.state == '进行中超时'
                        ? true
                        : false
                        " @click="compileSchedule(scope.row, 1)">{{ $t('工单任务.进度') }}</el-button>
                    </div>
                    <div v-show="region == 3">
                      <el-button type="primary" size="small" plain v-show="scope.row.state == '提前完成待验收' ||
                        scope.row.state == '验收超时'
                        ? true
                        : false
                        " @click="auditBtn(scope.row)">{{ $t('工单任务.验收') }}</el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination style="margin-top: 20px" align="center" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="pagenum" :page-sizes="[10, 50, 100]"
            :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </el-main>
      </el-container>
      <el-dialog :close-on-click-modal="false" :title="$t('工单任务.发起任务')" :visible.sync="addTask2" width="90%" top="2%">
        <el-row>
          <el-col :span="11" :offset="1">
            <h3 style="text-align: center; margin-bottom: 20px">
              {{ $t('工单任务.项目团队人员') }}
            </h3>
            <el-row>
              <el-col :span="20" :offset="4">
                <div class="head-text a">
                  <!-- 新建事件 -->
                  <el-input :placeholder="$t('工单任务.请输入用户姓名')" v-model="Sstext" class="search-input2"></el-input>
                  <el-button @click="Ss" slot="append" icon="el-icon-search" style="margin-right: 80px"></el-button>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="17" :offset="3">
                <div class="contentuserlist">
                  <div class="userNamelist" v-for="(i, index) in userList" :key="index" style="margin-top: 10px"
                    @click="addUser(i)">
                    <img style="width: 48px; height: 48px; border-radius: 6px" :src="$store.state.baseUrl + i.user13" />
                    <div class="gs" style="margin-left: 10px">
                      <h4>{{ i.prde03 }}</h4>
                      <p style="font-size: 12px">{{ i.user04 }}</p>
                    </div>
                  </div>
                </div>
                <el-pagination style="margin-top: 20px" align="center" @size-change="handleSizeChangeUser"
                  @current-change="handleCurrentChangeUser" :current-page="pagenum" :page-sizes="[10, 50, 100]"
                  :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
                  :total="Usertotal"></el-pagination>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <p style="text-align: center; margin-bottom: 20px; font-size: 20px">
              {{ $t('工单任务.执行人员') }}
            </p>
            <el-table :data="Objects" border style="width: 100%; margin-bottom: 20px" mex-height="300">
              <el-table-column align="center" prop="prde03" :label="$t('工单任务.部门')"></el-table-column>
              <el-table-column align="center" prop="user04" :label="$t('工单任务.姓名')"></el-table-column>
              <el-table-column align="center" :label="$t('工单任务.操作')">
                <template slot-scope="scope">
                  <el-button type="danger" plain size="mini" @click="removeren(scope.row)">{{ $t('工单任务.删除')
                  }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-form ref="ruleForm" :rules="rules" label-suffix="：" :model="form" label-width="170px">
              <el-form-item :label="$t('工单任务.任务名称')" prop="wkod02">
                <el-input v-model="form.wkod02" :placeholder="$t('工单任务.请输入任务名称')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('工单任务.任务内容')" prop="wkod03">
                <el-input v-model="form.wkod03" autosize type="textarea"></el-input>
              </el-form-item>
              <el-form-item :label="$t('工单任务.工作时间')" prop="WorkTime">
                <el-date-picker v-model="form.WorkTime" type="datetimerange" :picker-options="pickerOptions"
                  :range-separator="$t('工单任务.至')" :start-placeholder="$t('工单任务.开始日期')"
                  :end-placeholder="$t('工单任务.结束日期')" format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
              <el-form-item label="工单标签" prop="wkod12">
                <template>
                  <el-select filterable v-model="form.wkod12" clearable :placeholder="$t('工单任务.请选择')">
                    <el-option v-for="item in labels" :key="item.wost01" :label="item.wost02"
                      :value="item.wost02"></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item :label="$t('工单任务.重要程度')" prop="wkod06">
                <el-rate v-model="form.wkod06" style="margin-top: 10px" :colors="colors"></el-rate>
              </el-form-item>
              <el-form-item :label="$t('工单任务.紧急程度')" prop="wkod07">
                <el-rate v-model="form.wkod07" style="margin-top: 10px" :colors="colors1"></el-rate>
              </el-form-item>
              <el-form-item :label="$t('工单任务.审核人员')" prop="wkod08">
                <template>
                  <el-select filterable v-model="form.wkod08" clearable :placeholder="$t('工单任务.请选择')">
                    <el-option v-for="item in userListSh" :key="item.user01" :label="item.user04"
                      :value="item.user01"></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item :label="$t('工单任务.关联模型')">
                <el-button size="small" type="primary" plain @click="modelChooseList">{{ $t('工单任务.关联模型') }}</el-button>
                <el-row v-show="TypeData.length" style="margin-left: -20%; max-height: 200px; overflow: auto">
                  <el-col :span="12" v-for="(item, index) in TypeData" :key="index">
                    <el-row>
                      <el-col :span="20" :title="item.name">{{
                        item.name.length > 15
                          ? item.name.substr(0, 15) + "..."
                          : item.name
                      }}</el-col>
                      <el-col :span="4">
                        <el-button type="danger" size="mini" plain @click="deleteGetModelSelectList2Item(index)">{{
                          $t('工单任务.删除') }}</el-button>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('工单任务.关联资料')">
                <el-button size="small" type="primary" plain @click="associatedDataOpen">{{ $t('工单任务.关联资料')
                }}</el-button>
                <el-row v-show="GetFilesLinksList2.length" style="margin-left: -20%; max-height: 200px; overflow: auto">
                  <el-col :span="12" v-for="(item, index) in GetFilesLinksList2" :key="index">
                    <el-row>
                      <el-col :span="20" :title="item.prfl02">{{
                        item.prfl02.length > 15
                          ? item.prfl02.substr(0, 15) + "..."
                          : item.prfl02
                      }}</el-col>
                      <el-col :span="4">
                        <el-button type="danger" size="mini" plain @click="deletemultipleSelection2(index)">{{
                          $t('工单任务.删除')
                        }}</el-button>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('工单任务.截止时间')" prop="wkod09">
                <el-date-picker v-model="form.wkod09" type="datetime" :placeholder="$t('工单任务.选择日期时间')"
                  format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addBtn('ruleForm')">{{ $t('工单任务.确定') }}</el-button>
        </span>
      </el-dialog>
    </el-card>
    <!-- 我发起的——编辑 -->
    <el-dialog :close-on-click-modal="false" :title="$t('工单任务.任务进度')" :visible.sync="compileScheduleLoading" width="30%"
      center>
      <el-row style="width: 80%; margin: 10px auto 0">
        <el-col :span="4">
          <p style="line-height: 26px">{{ $t('工单任务.调节进度') }}:</p>
        </el-col>
        <el-col :span="14">
          <el-progress :text-inside="true" :stroke-width="34"
            :percentage="parseInt(forms.woli03) ? parseInt(forms.woli03) : 0" :color="customColors"></el-progress>
        </el-col>
        <el-col :span="6" style="margin: -3px 0 0 0">
          <el-input @change="progressNum" style="height: 35px" maxlength="3" type="number"
            v-model="forms.woli03"></el-input>
        </el-col>
      </el-row>
      <el-row style="width: 80%; margin: 10px auto 0">
        <el-col :span="4">
          <p>{{ $t('工单任务.成果说明') }}:</p>
        </el-col>
        <el-col :span="20">
          <el-input type="textarea" v-model="forms.woli04" :placeholder="$t('工单任务.请输入内容')"></el-input>
        </el-col>
      </el-row>
      <el-row style="width: 80%; margin: 10px auto 0">
        <el-col :span="20">
          <el-upload style="
              display: flex;
              justify-content: flex-start;
              align-items: center;
            " :action="actionUrl" class="upload-demo" ref="upload1" :data="forms" :limit="1" :on-exceed="handleExceed"
            :on-preview="handlePreview" :on-remove="handleRemove" :on-change="handleChange" :on-success="handlesuccesS"
            :before-upload="beforeUpload2" :file-list="fileList" :headers="importHeaders" :auto-upload="false">
            <el-button style="margin-right: 6px" slot="trigger" size="mini">{{ $t('工单任务.附件') }}</el-button>
          </el-upload>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="compileScheduleLoading = false">{{ $t('工单任务.取消') }}</el-button>
        <el-button type="primary" v-show="forms.woli03 != 100" @click="compileScheduleBtn">{{ $t('工单任务.发送')
        }}</el-button>
        <el-button type="warning" v-show="forms.woli03 == 100" @click="compileScheduleBtnSH">{{ $t('工单任务.申请审核')
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 我审核的——验收 -->
    <el-dialog :close-on-click-modal="false" :title="$t('工单任务.审核验收')" :visible.sync="compileScheduleLoading1"
      width="30%" center>
      <el-row style="width: 80%; margin: 10px auto 0">
        <el-col :span="4">
          <p>{{ $t('工单任务.验收意见') }}:</p>
        </el-col>
        <el-col :span="20">
          <el-input type="textarea" v-model="forms.woli04" :placeholder="$t('工单任务.请输入内容')"></el-input>
        </el-col>
      </el-row>
      <el-row style="width: 80%; margin: 10px auto 0">
        <el-col :span="20">
          <el-upload style="
              display: flex;
              justify-content: flex-start;
              align-items: center;
            " :action="actionUrl" class="upload-demo" ref="upload1" :data="forms" :on-preview="handlePreview"
            :on-remove="handleRemove" :on-change="handleChange" :before-upload="beforeUpload" :file-list="fileList"
            :headers="importHeaders" :auto-upload="false">
            <el-button style="margin-right: 6px" slot="trigger" size="mini">{{ $t('工单任务.附件') }}</el-button>
          </el-upload>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer" style="margin-left: 10px">
        <el-button type="danger" @click="nopass">{{ $t('工单任务.不通过') }}</el-button>
        <el-button type="primary" @click="pass">{{ $t('工单任务.通过') }}</el-button>
      </span>
    </el-dialog>

    <!-- 查看任务 -->
    <el-dialog :close-on-click-modal="false" :title="$t('工单任务.任务详情')" :visible.sync="examineDialog" width="95%" center>
      <el-row>
        <el-col :span="7" style="margin-left: 30px">
          <el-form :model="examineData">
            <el-form-item :label="$t('工单任务.发起人')" label-width="70px">
              <p style="color: #409eff">{{ examineData.requestUser }}</p>
            </el-form-item>
            <el-form-item :label="$t('工单任务.任务名称')" label-width="70px">
              <el-input v-model="examineData.wkod02" :disabled="orderState"></el-input>
            </el-form-item>
            <el-form-item :label="$t('工单任务.任务内容')" label-width="70px">
              <el-input resize="none" autosize type="textarea" v-model="examineData.wkod03"
                :disabled="orderState"></el-input>
            </el-form-item>
            <el-form-item :label="$t('工单任务.计划时间')" label-width="70px">
              <el-date-picker :disabled="orderState" type="datetime" v-model="examineData.wkod05" placeholder="选择日期时间"
                format="yyyy/MM/dd HH:mm:ss" value-format="yyyy/MM/dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('工单任务.工作标签')" label-width="70px">
              <el-select filterable v-model="examineData.wkod12" clearable :placeholder="$t('工单任务.请选择')"
                :disabled="orderState">
                <el-option v-for="item in labels" :key="item.wost01" :label="item.wost02"
                  :value="item.wost02"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('工单任务.重要程度')">
              <el-rate style="margin-top: 10px" :disabled="orderState" v-model="examineData.wkod06"
                :colors="colors"></el-rate>
            </el-form-item>
            <el-form-item :label="$t('工单任务.紧急程度')">
              <el-rate style="margin-top: 10px" :disabled="orderState" v-model="examineData.wkod07"
                :colors="colors1"></el-rate>
            </el-form-item>
            <el-form-item :label="$t('工单任务.关联模型')">
              <el-button size="small" type="primary" @click="modelChooseList">{{ $t('工单任务.添加') }}</el-button>
              <el-table :data="examineData.modelselectList" style="width: 100%" border max-height="400">
                <el-table-column type="index" width="55" :label="$t('工单任务.序号')" align="center"></el-table-column>
                <el-table-column prop="name" :label="$t('工单任务.名称')" align="center"></el-table-column>
                <el-table-column prop="type" :label="$t('工单任务.类型')" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.type == "1" ? $t('工单任务.选择集') : $t('工单任务.视点') }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('工单任务.截图')" align="center">
                  <template slot-scope="scope">
                    <img :src="$store.state.baseUrl + scope.row.pic" v-if="scope.row.pic != null" width="90px" />
                  </template>
                </el-table-column>
                <el-table-column :label="$t('工单任务.查看')" align="center" width="150px">
                  <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="viewModel(scope.row)">{{ $t('工单任务.查看') }}</el-button>
                    <el-button type="danger" size="small" @click="deleteModel(scope.row)">{{ $t('工单任务.删除')
                    }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item :label="$t('工单任务.附件')">
              <el-button @click="associatedDataOpen" size="small" type="primary">{{ $t('工单任务.新增') }}</el-button>
              <el-table :data="examineData.WorkattachmentList" style="width: 100%" border max-height="400">
                <el-table-column type="index" width="55" label="序号" align="center"></el-table-column>
                <el-table-column prop="prfl02" :label="$t('工单任务.名称')" align="center">
                  <template slot-scope="scope">
                    <a :href="scope.row.prfl07" target="_blank">{{
                      scope.row.prfl02
                    }}</a>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('工单任务.查看')" align="center" width="150px">
                  <template slot-scope="scope">
                    <el-button type="danger" size="small" @click="DelWorkFileLink(scope.row)">{{ $t('工单任务.删除')
                    }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8" style="margin: 0 40px">
          <el-form :model="examineData">
            <el-form-item :label="$t('工单任务.执行人')" label-width="80px">
              <el-input v-model="examineData.executeUser" :disabled="orderState"></el-input>
              <!-- <el-select
                filterable
                disabled
                v-model="examineData.wkod19"
                clearable
                placeholder="请选择"
                @change="changeZX"
              >
                <el-option
                  v-for="item in zhiXingUserList"
                  :key="item.user01"
                  :label="item.user04"
                  :value="item.user01"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item :label="$t('工单任务.状态')" label-width="80px">
              <p style="color: red">{{ examineData.state }}</p>
            </el-form-item>
            <el-form-item :label="$t('工单任务.时间范围')" label-width="80px">
              <el-date-picker v-model="dateRange" @change="changeDate" :disabled="orderState" type="datetimerange"
                :picker-options="pickerOptions" :range-separator="$t('工单任务.至')" :start-placeholder="$t('工单任务.开始日期')"
                :end-placeholder="$t('工单任务.结束日期')" format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy/MM/dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-form>
          <div style="display: flex">
            <p style="margin-left: 30px">{{ $t('工单任务.进度') }}</p>
            <el-progress style="width: 70%; margin-left: 10px" :text-inside="true" :stroke-width="26"
              :percentage="examineData.wkod18 == null ? 0 : examineData.wkod18" :color="customColors"></el-progress>
          </div>
          <!-- 任务完成列表 -->
          <el-table :data="examineData.progressList" border style="width: 100%; margin: 20px 0">
            <el-table-column prop="woli07" align="center" :label="$t('工单任务.时间')"></el-table-column>
            <el-table-column prop="woli03" align="center" :label="$t('工单任务.进度')">
              <template slot-scope="scope">
                <el-progress :text-inside="true" :stroke-width="26"
                  :percentage="scope.row.woli03 == null ? 0 : scope.row.woli03" :color="customColors"></el-progress>
              </template>
            </el-table-column>
            <el-table-column prop="woli04" align="center" :label="$t('工单任务.内容')"></el-table-column>
            <el-table-column prop="atta03" align="center" :label="$t('工单任务.附件')">
              <template slot-scope="scope">
                <a v-if="scope.row.atta05 != null" :href="httpss + scope.row.atta05">
                  <el-button class="textOverflow" :title="scope.row.atta03" size="mini" type="primary">
                    <p>{{ scope.row.atta03 }}</p>
                  </el-button>
                </a>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="7" style="margin-left: 10px">
          <el-form :model="examineData">
            <el-form-item :label="$t('工单任务.审核人员')" label-width="80px">
              <el-input v-model="examineData.auditUser" :disabled="orderState"></el-input>
              <!-- <el-select
                filterable
                disabled
                v-model="examineData.wkod08"
                clearable
                placeholder="请选择"
                @change="changeSH"
              >
                <el-option
                  v-for="item in zhiXingUserList2"
                  :key="item.user01"
                  :label="item.user04"
                  :value="item.user01"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item :label="$t('工单任务.截止时间')" label-width="80px">
              <el-date-picker v-model="examineData.wkod09" type="datetime" placeholder="选择日期时间"
                format="yyyy/MM/dd HH:mm:ss" value-format="yyyy/MM/dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('工单任务.验收完成')" label-width="80px">
              <p>{{ examineData.woli07 }}</p>
            </el-form-item>
            <el-form-item :label="$t('工单任务.验收意见')" label-width="80px">
              <el-input resize="none" type="textarea" autosize v-model="examineData.woli04" disabled></el-input>
            </el-form-item>
          </el-form>
          <div style="display: flex">
            <p style="margin-left: 30px">{{ $t('工单任务.附件') }}：</p>
            <a :href="httpss + i.atta05" v-for="(i, index) in examineData.attachmentList" :key="index">
              <el-button size="mini" :title="i.atta03" class="textOverflow" type="primary">
                <p>{{ i.atta03 }}</p>
              </el-button>
            </a>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="UpdateWorkOrderAll">{{ $t('工单任务.确定') }}</el-button>
        <el-button style="margin-top: 30px" type="danger" @click="examineDialog = false">{{ $t('工单任务.取消') }}</el-button>
      </span>
    </el-dialog>
    <!-- 这里是视点关联 -->

    <el-dialog :close-on-click-modal="false" :title="$t('工单任务.关联模型')" :visible.sync="modelChooseListOpen" width="60%"
      center>
      <el-row>
        <el-col :span="6" v-for="(item, index) in TypeData" :key="index">
          <el-row>
            <el-col :span="16" :title="item.name">
              <p>
                {{
                  item.name.length > 5
                    ? item.name.substr(0, 5) + "..."
                    : item.name
                }}
              </p>
            </el-col>
            <el-col :span="8">
              <el-button style="position: relative; top: -4px" type="danger" plain size="mini"
                @click="deleteGetModelSelectList2Item(index)">{{ $t('工单任务.删除') }}</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- 11 -->
      <el-container>
        <el-aside width="200px" style="
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            height: 100%;
            text-align: center;
          " class="elAside">
          <div class="zTreeDiv">
            <ul id="WorkPlaneTree" class="ztree"></ul>
          </div>
        </el-aside>
        <el-main>
          <el-row>
            <el-col :span="4">
              <el-select filterable v-model="TypeName" @change="TypehandleClick" :title="$t('工单任务.请选择类型')"
                :placeholder="$t('工单任务.请选择类型')">
                <el-option key="1" :label="$t('工单任务.选择集')" value="1"></el-option>
                <el-option key="2" :label="$t('工单任务.视点')" value="3"></el-option>
              </el-select>
            </el-col>
            <el-col :span="11">
              <div class="head-text">
                <!-- 新建事件 -->
                <el-input :placeholder="$t('工单任务.输入关键字')" style="width: 250px" class="search-input"
                  v-model="query2"></el-input>
                <el-button slot="append" icon="el-icon-search" @click="aa"></el-button>
              </div>
            </el-col>
          </el-row>

          <el-table ref="multipleTable" :data="GetModelSelectList" tooltip-effect="dark" style="width: 100%"
            height="550px" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" :label="$t('工单任务.名字')"></el-table-column>
          </el-table>

          <el-row>
            <el-col :span="3" :offset="9">
              <el-button type="primary" style="margin-left: 10px" @click="modelChooseListClose">{{ $t('工单任务.确定')
              }}</el-button>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="$t('工单任务.关联资料')" :visible.sync="associatedData" width="80%"
      top="100px" center>
      <el-row>
        <el-col :span="4" v-for="(item, index) in GetFilesLinksList2" :key="index">
          <el-row>
            <el-col :span="16" :title="item.prfl02">{{
              item.prfl02.length > 8
                ? item.prfl02.substr(0, 8) + "..."
                : item.prfl02
            }}</el-col>
            <el-col :span="4">
              <el-button style="position: relative; top: -4px" size="small" @click="deleteGetFilesLinksList2Item(index)"
                type="danger" plain>{{ $t('工单任务.删除') }}</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-container>
        <el-aside width="200px" style="text-align: center">
          <!-- <el-tree :data="TreeData" :props="defaultProps" @node-click="handleNodeClick">
            <span slot-scope="{ node, data }">
              <span>{{ node.label }} ({{data.Count}})</span>
            </span>
          </el-tree>-->
          <el-button type="primary" size="small" @click="showAll">{{ $t('工单任务.显示全部文件') }}</el-button>
          <div class="zTreeDiv">
            <ul id="ProjectFileTree" class="ztree"></ul>
          </div>
          <div id="dataListRemenu" v-if="
            ($store.state.permissions != null &&
              $store.state.permissions.includes('701')) ||
            $store.state.isProject
          ">
            <ul>
              <li id="addDataList">{{ $t('工单任务.新增资料') }}</li>
            </ul>
          </div>
        </el-aside>
        <el-main>
          <div class="head-text" style="float: right">
            <!-- 新建事件 -->
            <el-input :placeholder="$t('工单任务.请输入文件名')" style="width: 200px" class="search-input"
              v-model="query3"></el-input>
            <el-button slot="append" icon="el-icon-search" @click="bb" style="margin-right: 80px"></el-button>
          </div>
          <el-table ref="multipleTable" :data="GetFilesLinksList" tooltip-effect="dark" style="width: 100%"
            height="500px" @selection-change="handleSelectionChange2">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="prfl02" :label="$t('工单任务.名字')"></el-table-column>
          </el-table>
          <el-row>
            <el-col :span="3" :offset="8">
              <el-button type="success" @click="associatedData = false">{{ $t('工单任务.确定关联') }}</el-button>
            </el-col>
            <el-col :span="3">
              <el-button type="danger" @click="associatedDataClose">{{ $t('工单任务.取消') }}</el-button>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog :close-on-click-modal="false" :title="$t('工单任务.新增资料')" :visible.sync="dialogVisible" width="40%">
      <el-row>
        <el-col :span="12">
          <el-upload class="upload-demo" ref="upload" :action="actionUrl3" :on-preview="handlePreview"
            :on-remove="handleRemove" :before-upload="handleBefore" :file-list="fileList" :auto-upload="false"
            :data="aaa" :headers="importHeaders" :on-success="handleSuccess">
            <el-button slot="trigger" size="small" type="primary">{{ $t('工单任务.选取文件') }}</el-button>
          </el-upload>
        </el-col>
        <el-col :span="12">
          {{ $t('工单任务.可见设置') }}：
          <el-radio v-model="radio" :label="1">{{ $t('工单任务.公开') }}</el-radio>
          <el-radio v-model="radio" :label="2">{{ $t('工单任务.半公开') }}</el-radio>
          <div style="
              border: 2px solid #eee;
              height: 200px;
              max-height: 200px;
              overflow: auto;
              width: 80%;
              box-sizing: border-box;
            " v-if="radio == 2">
            <el-row style="padding: 10px">
              <el-col :span="8" v-for="(item, index) in multipleSelection3" :key="index" style="padding-top: 10px">
                <el-row style="padding: 0px">
                  <el-col :span="20">{{ item.user04 }}</el-col>
                  <el-col :span="4">
                    <span style="color: red; cursor: pointer" @click="delectUser(index)">x</span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-button type="primary" size="small" style="margin: 10px" v-if="radio == 2" @click="dialogVisible1OPen">{{
            $t('工单任务.添加') }}</el-button>
        </el-col>
      </el-row>
      <el-row style="height: 80px">
        <el-col :span="3" :offset="8">
          <el-button type="primary" style="width: 100%" @click="submitUpload">{{ $t('工单任务.上传') }}</el-button>
        </el-col>
        <el-col :span="3" :offset="1">
          <el-button type="primary" style="width: 100%" @click="dialogVisible = false">{{ $t('工单任务.取消') }}</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 项目下的人员列表 -->
    <el-dialog :close-on-click-modal="false" :title="$t('工单任务.请选择人员')" :visible.sync="dialogVisible1" width="25%">
      <div class="head-text">
        <!-- 新建事件 -->
        <el-input v-model="selectName" :placeholder="$t('工单任务.请输入名称')" class="search-input"
          style="width: 80%"></el-input>
        <el-button @click="dialogVisible1OPen" slot="append" icon="el-icon-search"></el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData3" tooltip-effect="dark" style="width: 100%" max-height="400"
        @selection-change="handleSelectionChange3">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" :label="$t('工单任务.序号')" width="100"></el-table-column>
        <el-table-column prop="user02" :label="$t('工单任务.帐号')"></el-table-column>
        <el-table-column prop="user04" :label="$t('工单任务.姓名')"></el-table-column>
      </el-table>
      <div style="width: 100%; height: 40px; margin-top: 10px; text-align: center">
        <el-button type="primary" size="small" @click="dialogVisible1 = false">{{ $t('工单任务.确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "@/lib/asyncFZ";
import {
  UpdateWorkOrderTime,
  HandelWorkOrder,
  ReadWorkOrder,
  GetWorkOrderInfo,
  AddWorkOrderMsg,
  GetProjectModelList,
  GetModelSelect,
  GetProjectFileZTree,
  GetFilesLinks,
  GetProUsersList,
  GetUsersWithoutMe,
  GetAuditUserList2,
  AddWorkOrderUser,
  DelWorkOrder,
  GetWorkOrderList,
  GetWorkOrderSet,
  GetModelSelectOrViewPoint,
  GetSelectOrView,
  AddModelLink,
  DelModelLink,
  AddWorkFileLink,
  DelWorkFileLink,
  UpdateWorkOrderAll,
  GetFileWhitOutUserList,
  GetWorkPlaneTree2,
  FindWorkPlaneModel,
} from "@/setAxios";
export default {
  data() {
    return {
      mid: 0,
      pid: -1,
      options: [],
      multipleSelection3: [],
      selectName: "",
      dialogVisible1: false,
      radio: "",
      aaa: {
        uid: localStorage.getItem("id"),
        Uids: "",
        xid: localStorage.getItem("xid"),
        type: 1,
        gid: 0,
        qid: localStorage.getItem("pid"),
      },
      fid: 0,
      isClick: false,
      tableData3: [],
      dialogVisible: false,
      dateRange: ["2020-6-4 00:00:00", "2020-07-07 00:00:00"],
      zhiXingUserList: [],
      zhiXingUserList2: [],
      zhiXingUserList2Copy: [],
      workOrderId: "",
      orderState: false,
      TypeData: [],
      TypeName: "1",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [end, start]);
            },
          },
        ],
      },
      // 是否有附件
      accessory: false,
      Numberss: 0,
      modelChooseListOpen: false,
      associatedData: false,
      httpss: this.$store.state.baseUrl,
      // 进度上传附件接口
      actionUrl: this.$store.state.baseUrl + "/api/HandelWorkOrder",
      // 发起上传验收接口
      actionUrl2: this.$store.state.baseUrl + "/api/AddWorkOrderUser",
      actionUrl3: this.$store.state.baseUrl + "/api/UploadDataFile",
      // 进度对话框
      compileScheduleLoading: false,
      // 审核对话框
      compileScheduleLoading1: false,
      // 选中
      pitch: 1,
      // 查看框
      examineDialog: false,
      // 查看数据
      examineData: {},
      // 催办数量2
      lengths2: 0,
      lengths3: 0,
      // 搜索工单名称
      cxorderText: "",
      // 搜索项目成员
      Sstext: "",
      value: "",
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      colors1: ["#99A9BF", "#F7BA2A", "#FF9900"],
      addTask2: false,

      form: {
        qid: localStorage.getItem("pid"),
        wkod10: localStorage.getItem("xid"),
        wkod11: localStorage.getItem("id"),
        wkod08: "",
        wkod12: "",
        wkod14: null,
        wkod15: [],
      },
      pagenum: 1,
      pagesize: 10,
      total: 0,
      Usertotal: 0,
      loading: false,
      region: 1,
      region2: 1,
      workOrder: [],
      // 模型关联
      modelName: "",
      ids: "",
      query2: "",
      query3: "",
      ModelList: [],
      GetModelSelectList: [],
      GetModelSelectList2: [],
      GetFilesLinksList: [],
      GetFilesLinksList2: [],
      userList: [],
      userListSh: [],
      Objects: [],
      labels: [],
      TreeData: [],
      // tree配置
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 进度条
      forms: {
        //关联工单id
        woli02: 0, //必填
        // 进度
        woli03: 0,
        // 内容
        woli04: null,
        // 类型 1为进度修改 2为验收意见
        woli05: 1,
        // 创建人ID
        woli06: localStorage.getItem("id"),
        // 是否通过 0未通过  1通过  woli04=2可用
        woli08: 1,
        // 项目ID
        xid: localStorage.getItem("xid"),
      },

      importHeaders: { token: localStorage.getItem("token") },
      fileList: [],
      customColors: [
        { color: "red", percentage: 20 },
        { color: "#e6a23c", percentage: 70 },
        { color: "#6f7ad3", percentage: 90 },
        { color: "#5cb87a", percentage: 100 },
      ],
      // 进度条结束

      // 表单判断
      rules: {
        wkod02: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
        ],
        wkod12: [
          { required: true, message: "请选择工作标签", trigger: "change" },
        ],
        wkod08: [
          { required: true, message: "请选择审核人员", trigger: "change" },
        ],
        WorkTime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        wkod09: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        wkod03: [
          { required: true, message: "请填写任务内容", trigger: "blur" },
        ],
      },
      selectNode: null,
      zTeeObj: null,
    };
  },
  methods: {
    tableRowClassIndex({ row, rowIndex }) {
      if (this.$route.params) {
        let index = this.workOrder.findIndex(
          (ele) => ele.wkod01 == this.$route.params.wkod01
        );
        if (rowIndex === index) {
          return "warning-index";
        }
        return "";
      }
    },
    showAll() {
      this.fid = "null";
      this.bb();
    },
    //初始化ztree
    init() {
      var _this = this;

      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "pftr02",
          },
          simpleData: {
            enable: true,
            idKey: "pftr01",
            pIdKey: "pftr03",
          },
        },
        callback: {
          onCheck: onCheck,
          onClick: onclick,
          onRightClick: OnRightClick,
        },
      };

      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          _this.aaa.gid = treeNode.pftr01;
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "dataListRemenu" ||
            $(event.target).parents("#dataListRemenu").length > 0
          )
        ) {
          $("#dataListRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type != "root") {
          $("#dataListRemenu").show();
          $("#addDataList").show();
          $("#dataListRemenu").css({
            top: y + "px",
            left: x + "px",
            visibility: "visible",
          }); //设置右键菜单的位置、可见
          $("body").bind("mousedown", onBodyMouseDown);
        }
      }

      $("#dataListRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#dataListRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addDataList") {
            _this.dialogVisible = true;
          }
        });

      this.zTeeObj = $.fn.zTree.init(
        $("#ProjectFileTree"),
        setting,
        this.TreeData
      );
      this.zTeeObj.checkAllNodes(true);
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.fid = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.fid += _split + element.pftr01;
        _split = ",";
      });
      _this.bb();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.fid = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.fid += _split + element.pftr01;
          _split = ",";
        });
        _this.bb();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.fid = treeNode.pftr01;
        _this.bb();
      }
    },
    delectUser(index) {
      this.multipleSelection3.splice(index, 1);
      this.$message({
        type: "success",
        message: this.$t('common.处理成功'),
      });
    },
    dialogVisible1OPen() {
      this.dialogVisible1 = true;
      let params = {
        searchword: this.selectName,
        fid: 0,
        xid: localStorage.getItem("xid"),
      };
      GetFileWhitOutUserList({ params }).then((res) => {
        this.tableData3 = res.Data.list;
      });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleSuccess(response, file, fileList) {
      if (response.Code > 0) {
        this.$message({
          type: "success",
          message: this.$t('common.处理成功'),
        });
        this.dialogVisible = false;
        this.bb();
      }
    },
    handleBefore(file) {
      let fd = new FormData();
      this.aaa.type = this.radio;
      let userID = [];
      this.multipleSelection3.forEach((ele) => {
        userID.push(ele.user01);
      });
      this.aaa.Uids = userID.join(",");
      fd.append("file", file);
      fd.append("model", this.aaa);
    },
    handleSelectionChange3(val) {
      this.multipleSelection3 = val;
    },
    dialogVisibleOpen() {
      if (this.isClick == false) {
        this.$message({
          type: "warning",
          message: this.$t('common.请先选择'),
        });
      } else {
        this.dialogVisible = true;
      }
    },
    async UpdateWorkOrderAll() {
      let params = JSON.stringify(this.examineData);
      let res = await UpdateWorkOrderAll({ model: params });
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: this.$t('common.处理成功'),
        });
        this.examineDialog = false;
      }
    },
    changeSH(data) { },
    changeZX(data) { },
    changeDate(data) {
      this.examineData.wkod04 = data[0];
      this.examineData.wkod05 = data[1];
    },
    async AddWorkFileLink() {
      if (this.orderState) {
        this.associatedData = false;
      } else {
        let FileIds = [];
        this.GetFilesLinksList2.forEach((ele) => {
          FileIds.push(ele.prfl01);
        });
        FileIds = FileIds.join(",");
        let params = {
          wid: this.workOrderId,
          FileIds,
        };
        let res = await AddWorkFileLink(params);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: this.$t('common.处理成功'),
          });
          this.seeInfo2();
          this.associatedData = false;
        }
      }
    },
    async deleteModel(data) {
      let params = {
        wid: this.workOrderId,
        list: data,
      };
      let res = await DelModelLink(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: this.$t('common.处理成功'),
        });
        this.seeInfo2();
      }
    },
    async DelWorkFileLink(data) {
      let a = data;
      let params = {
        wid: this.workOrderId,
        fid: data.prfl01,
      };
      let res = await DelWorkFileLink(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: this.$t('common.处理成功'),
        });
        this.seeInfo2();
      }
    },
    modelChooseList() {
      this.modelChooseListOpen = true;
      let params = {
        xid: localStorage.getItem("xid"),
        pid: this.pid,
      };
      GetWorkPlaneTree2(params).then((res) => {
        this.options = res.Data;
        this.options.forEach((item) => {
          this.judge(item);
        });
        this.init2();
      });
    },
    init2() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "label",
          },
          simpleData: {
            enable: true,
            idKey: "ID",
            pIdKey: "ParentId",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onClick: onclick,
        },
      };
      var objs = $.fn.zTree.init($("#WorkPlaneTree"), setting, this.options);
      if (objs != null) {
        if (localStorage.treeNid) {
          var currentNode = objs.getNodeByParam("ID", localStorage.treeNid);
          var name = currentNode.tId + "_a";
          $("#" + name).click();
        } else {
          $("#WorkPlaneTree_1_a").click();
        }
      }
      function onclick(event, treeId, treeNode) {
        if (treeNode.wopl07 == 1) {
          let params = {
            id: treeNode.ID,
          };
          FindWorkPlaneModel(params).then((res) => {
            if (res.Data == null) {
              _this.$message({
                type: "warning",
                message: this.$t('工单任务.此节点未绑定模型或选择集'),
              });
              return false;
            }
            let data = res.Data;
            _this.mid = data.modelId;
            let params = {
              seachword: _this.query2,
              mid: data.modelId,
              type: _this.TypeName,
              uid: localStorage.getItem("id"),
            };
            GetModelSelectOrViewPoint(params).then((res) => {
              _this.GetModelSelectList = res.Data;
            });
          });
        } else {
          _this.mid = -1;
          _this.GetModelSelectList = [];
          _this.$message({
            type: "warning",
            message: this.$t('工单任务.只可选择单模'),
          });
        }
      }
    },
    // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },
    aa() {
      let params = {
        seachword: this.query2,
        mid: this.mid,
        type: this.TypeName,
        uid: localStorage.getItem("id"),
      };
      GetModelSelectOrViewPoint(params).then((res) => {
        this.GetModelSelectList = res.Data;
      });
    },
    deleteGetFilesLinksList2Item(data) {
      this.GetFilesLinksList2.splice(data, 1);
      this.pushModelIds();
    },
    associatedDataOpen() {
      this.associatedData = true;
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetProjectFileZTree({ params }).then((res) => {
        this.TreeData = res.Data;
        this.init();
      });
    },
    // 查看模型
    viewModel(row) {
      let params = {
        id: row.id,
        type: row.type,
      };
      GetSelectOrView(params).then((res) => {
        let type = "modelSelect";
        if (res.Data.type == 3) {
          type = "viewpoint";
        }
        let params = `modelId=${res.Data.modelId}^@^type=${type}^@^state=${res.Data.state}^@^id=${res.Data.id}`;
        params = Base64.encode(params);
        let url = `#/viewModel?Code=${params}`;
        window.open(url);
      });
    },
    // 搜索工单
    cxorder(name) {
      let params = {
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        type: 1,
        indexPage: this.pagenum,
        pageSize: this.pagesize,
        seachword: name,
      };
      GetWorkOrderList({ params }).then((res) => {
        //(res, "resName");
        // this.labels=res.Data.list
        this.workOrder = res.Data.list;
        this.total = res.Data.total;
      });
    },
    // 搜索项目人员
    Ss() {
      let params = {
        id: localStorage.getItem("xid"),
        cid: localStorage.getItem("pid"),
        pageIndex: this.pagenum,
        uid: localStorage.getItem("id"),
        pageSize: this.pagesize,
        seachword: this.Sstext,
      };
      GetUsersWithoutMe({ params }).then((res) => {
        this.userList = res.Data.list;
        this.Usertotal = res.Data.total;
      });
    },
    // 这里是添加任务
    addTask() {
      this.orderState = true;
      this.addTask2 = true;
      this.form = this.$options.data.call(this).form;
      this.fileList = this.$options.data.call(this).fileList;
      this.Objects = this.$options.data.call(this).Objects;
      this.GetModelSelectList2 =
        this.$options.data.call(this).GetModelSelectList2;
      this.getUser();
    },
    getUser() {
      let params = {
        id: localStorage.getItem("xid"),
        cid: localStorage.getItem("pid"),
        uid: localStorage.getItem("id"),
        seachword: "",
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      // 获取成员
      GetUsersWithoutMe({ params }).then((res) => {
        //(res, "Userres");
        this.userList = res.Data.list;
        this.Usertotal = res.Data.total;
      });
    },
    // 添加任务确定按钮
    addBtn(formName) {
      if (this.Objects == 0) {
        this.$message({
          message: this.$t('工单任务.未选择执行任务人员'),
          type: "warning",
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addTask2 = false;
          let arrays = [];
          this.Objects.map((item) => {
            arrays.push(item.user01);
          });
          this.form.Uids = arrays.toString();
          this.form.WorkTime = this.form.WorkTime.toString();
          this.form.list = this.TypeData.length == 0 ? null : this.TypeData;
          this.form.qid = localStorage.getItem("pid");
          this.form.FileIds = [];
          this.GetFilesLinksList2.forEach((ele) => {
            this.form.FileIds.push(ele.prfl01);
          });
          this.form.FileIds = this.form.FileIds.join(",");
          if (this.accessory) {
            this.$refs.upload.submit();
          } else {
            let params = this.form;
            AddWorkOrderUser(params).then((res) => {
              if (res.Code > 0) {
                this.$message({
                  type: "success",
                  // message: "成功发布 " + res.Code + " 个工单",
                  message: this.$t('common.处理成功')
                });
                this.getData(1);
              } else {
                this.$message.error(this.$t('common.处理失败'));
              }
              this.getData(1);
            });
          }
          this.form = this.$options.data.call(this).form;
        } else {
          this.$message({
            // message: "表单填写有误",
            message: this.$t('common.处理失败'),
            type: "warning",
          });
          return false;
        }
      });
    },
    // 删除已选人员
    removeren(row, index) {
      this.Objects = this.Objects.filter((item) => item.user01 != row.user01);
      // console.log(this.Objects);
      this.Fc();
    },
    // 删除工单
    removeOrder(row) {
      // //(row);
      let params = JSON.stringify(row.wkod01);
      this.$confirm(this.$t('工单任务.是否撤销该工单任务'), this.$t('common.提示'), {
        confirmButtonText: this.$t('common.确定'),
        cancelButtonText: this.$t('common.取消'),
        type: "warning",
      })
        .then(() => {
          DelWorkOrder({ wid: params }).then((res) => {
            if (res.Code == 1) {
              this.$message({
                type: "success",
                message: this.$t('common.处理成功'),
              });
              this.getData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('common.取消'),
          });
        });
    },
    // 我发起的——催办
    press(row, index) {
      //(index);
      let params = {
        wid: row.wkod01,
        type: index,
      };
      AddWorkOrderMsg({ ...params }).then((res) => {
        //(res, "preess");
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: this.$t('工单任务.催办成功'),
          });
          this.getData();
        } else {
          this.$message({
            message: this.$t('工单任务.已催办待执行'),
            type: "warning",
          });
          this.getData();
        }
      });
    },
    // 我执行的————启动
    startBtn(row, index) {
      //(index);
      let wids = JSON.stringify(row.wkod01);
      let types = JSON.stringify(index);
      UpdateWorkOrderTime({ wid: wids, type: types }).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: index == 1 ? this.$t('工单任务.启动成功') : this.$t('工单任务.申请审核成功'),
          });
          this.getData(2);
        }
      });
    },
    // 我执行的————编辑进度
    compileSchedule(row, index) {
      //(row);
      this.lengths = 2;
      this.compileScheduleLoading = true;
      // 赋给forms工单ID
      this.forms.woli02 = row.wkod01;
      this.forms.woli03 = row.wkod18;
      // index  为  1/2   进度修改/验收
      this.forms.woli05 = index;
      let params = {
        wid: row.wkod01,
      };
      GetWorkOrderInfo({ params }).then((res) => {
        //(res, "ssss");
      });
    },
    // 我执行的————催办
    executeStartBtn(row) {
      //(row);
      let params = {
        wid: row.wkod01,
        type: 1,
      };
      AddWorkOrderMsg({ ...params }).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: this.$t('工单任务.催办成功'),
          });
          this.getData();
        } else {
          this.$message({
            message: this.$t('工单任务.已催办待执行'),
            type: "warning",
          });
          this.getData(2);
        }
      });
    },
    // 进度条控制
    progressNum(i) {
      // //(i);
      if (i > 100) {
        i = 100;
      } else if (i < 0) {
        i = 0;
      }
      this.forms.woli03 = parseInt(i);
    },
    increase() {
      this.forms.woli03 += 10;
      if (this.forms.woli03 > 100) {
        this.forms.woli03 = 100;
      }
    },
    decrease() {
      this.forms.woli03 -= 10;
      if (this.forms.woli03 < 0) {
        this.forms.woli03 = 0;
      }
    },
    // 我执行的————编辑进度————确定键
    compileScheduleBtn(num, type) {
      if (this.forms.woli04) {
        this.compileScheduleLoading1 = false;
        this.compileScheduleLoading = false;
        if (this.accessory) {
          this.$refs.upload1.submit();
          this.getData(2);
        } else {
          HandelWorkOrder({ ...this.forms }).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: this.$t('common.处理成功'),
              });
              this.getData(2);
              this.forms = this.$options.data.call(this).forms;
            }
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: this.$t('common.请填写必填项'),
        });
      }
    },
    // 这里是进度条昂
    format(percentage) {
      return percentage === 100 ? "100%" : `${percentage}%`;
    },
    // 这里是查看详情
    async seeInfo(data) {
      this.workOrderId = data.wkod01;
      this.orderState = data.state == "待启动" ? false : true;
      this.examineDialog = true;
      var params = {
        uid: localStorage.id,
        id: localStorage.xid,
        cid: localStorage.pid,
        pageIndex: 1,
        pageSize: 999999,
        seachword: "",
      };
      var res = await GetUsersWithoutMe({ params });
      this.zhiXingUserList = res.Data.list;
      params = {
        id: localStorage.xid,
        cid: localStorage.pid,
        pageIndex: 1,
        pageSize: 999999,
        seachword: "",
      };
      res = await GetProUsersList({ params });
      this.zhiXingUserList2 = res.Data.list;
      this.zhiXingUserList2Copy = res.Data.list;
      this.seeInfo2();
    },
    seeInfo2() {
      let params = {
        wid: this.workOrderId,
      };
      GetWorkOrderInfo({ params }).then((res) => {
        this.examineData = res.Data;
        this.dateRange = [res.Data.wkod04, res.Data.wkod05];
      });
      if (this.region == 2) {
        params = {
          wid: this.workOrderId,
          type: 2,
        };
        ReadWorkOrder({ params }).then((res) => {
          this.getData(this.region);
        });
      } else if (this.region == 3) {
        params = {
          wid: this.workOrderId,
          type: 1,
        };
        ReadWorkOrder({ params }).then((res) => {
          //(res, "我审批的阅读催办");
          this.getData(this.region);
        });
      }
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData(this.region);
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getData(this.region);
    },
    handleSizeChangeUser(val) {
      this.pagesize = val;
      this.getUser();
    },
    handleCurrentChangeUser(val) {
      this.pagenum = val;
      this.getUser();
    },
    // 这里获取所有数据
    getData(num) {
      this.loading = true;
      this.region == num;
      let params = {
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        type: num ? num : 1,
        indexPage: this.pagenum,
        pageSize: this.pagesize,
        seachword: "",
      };
      GetWorkOrderList({ params }).then((res) => {
        this.loading = false;
        this.workOrder = res.Data.list;
        this.total = res.Data.total;
        if (num == 2) {
          this.lengths2 = res.Data.list.filter((item, index) => {
            return item.Fuck == true;
          }).length;
        } else if (num == 3) {
          this.lengths3 = res.Data.list.filter((item, index) => {
            return item.Fuck == true;
          }).length;
        }
      });
      params = {
        xid: localStorage.getItem("xid"),
      };
      GetWorkOrderSet({ params }).then((res) => {
        this.labels = res.Data;
      });
    },

    getDataNum(num) {
      let params = {
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        type: num,
        indexPage: this.pagenum,
        pageSize: this.pagesize,
        seachword: "",
      };
      GetWorkOrderList({ params }).then((res) => {
        if (num == 2) {
          this.lengths2 = res.Data.list.filter((item, index) => {
            return item.Fuck == true;
          }).length;
        } else if (num == 3) {
          this.lengths3 = res.Data.list.filter((item, index) => {
            return item.Fuck == true;
          }).length;
        }
      });
    },

    // 点击切换我发起的/我审批的
    regionUpdate(i) {
      // 判断是否选中
      this.pitch = i;
      // 判断查阅类型
      this.region = i;
      // 切换获取数据类型
      this.getData(i);
    },
    addUser(i) {
      this.Objects.push(i);
      this.Objects = this.RemoveArr(this.Objects);
      // 这里有问题
      this.Fc();
    },
    RemoveArr(arr) {
      var arr1 = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr1.map((x) => x.user01).indexOf(arr[i].user01) == -1) {
          arr1.push(arr[i]);
        }
      }
      return arr1;
    },
    Fc() {
      this.form.wkod08 = "";
      let _split = "";
      this.ids = "";
      this.Objects.forEach((v) => {
        this.ids += _split + v.user01;
        _split = ",";
      });

      let params = {
        xid: localStorage.getItem("xid"),
        qid: localStorage.getItem("pid"),
        ids: this.ids,
      };
      GetAuditUserList2(params).then((res) => {
        // console.log(res, "kanzhe");
        this.userListSh = res.Data;
      });
    },
    // 上传附件
    handleRemove(file, fileList) {
      // 删除事件
      this.accessory = false;
    },
    handlePreview(file) {
      // console.log("1");
      //(file);
    },
    beforeUpload2(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("forms", JSON.stringify(this.forms));
    },
    beforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("form", JSON.stringify(this.form));
    },
    //上传成功
    handlesuccess(response, file, fileList) {
      //(response, file, fileList, "sss");
      if (response.Code > 0) {
        this.$message({
          type: "success",
          message: this.$t('工单任务.成功发布') + " " + response.Code + " " + this.$t('工单任务.个工单'),
        });
        this.getData(1);
      } else {
        this.$message.error(this.$t('common.处理失败'));
      }
    },
    handlesuccesS(response, file, fileList) {
      this.$message({
        type: "success",
        message: this.$t('common.处理成功'),
      });
      this.getData();
    },
    // 附件放对象里面
    handleChange(file, fileList) {
      this.accessory = true;
      const isLt500M = file.size / 1024 / 1024 < 500;
      if (!isLt500M) {
        this.$message({
          message: this.$t('工单任务.上传文件大小不能超过500MB'),
          type: "warning",
        });
      }
      return isLt500M;
    },
    handleExceed(files, fileList) {
      let message = `${this.$t('工单任务.当前限制选择1个文件本次选择了')}
    ${files.length}${this.$t('工单任务.个文件')}
    ${this.$t('工单任务.共选择了')}
    ${files.length + fileList.length}
    ${this.$t('工单任务.个文件')}`
      this.$message.warning(message);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`${this.$t('工单任务.确定移除')} ${file.name}？`);
    },
    // 申请审核
    compileScheduleBtnSH() {
      let params = {
        wid: this.forms.woli02,
        type: 2,
      };
      UpdateWorkOrderTime(params).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: this.$t('common.处理成功'),
          });
          this.compileScheduleBtn();
          this.getData(2);
        }
      });
    },
    // 审核审批
    auditBtn(row) {
      this.compileScheduleLoading1 = true;
      // 赋给forms工单ID
      this.forms.woli02 = row.wkod01;
    },
    // 通过
    pass() {
      this.forms.woli05 = 2;
      this.forms.woli08 = 1;
      this.region == 3;
      this.compileScheduleBtn(3);
    },
    // 不通过
    nopass() {
      this.forms.woli05 = 2;
      this.forms.woli08 = 0;
      this.region == 3;
      this.compileScheduleBtn(3);
    },
    // 模型关联
    pushModelIds(type) {
      //(type, this.GetModelSelectList2, "types");
      // wkod14模型选择接口目前只能接受一个int类型的ID,并不是数组ID
      this.GetModelSelectList2.forEach((item) => {
        this.form.wkod15.push(item.mosl01);
      });
    },
    deleteGetModelSelectList2Item(data) {
      //(data, "deleteGetModelSelectList2Item");

      // this.GetModelSelectList2.splice(data, 1);
      this.TypeData.splice(data, 1);
      // console.log(this.TypeData);
      this.pushModelIds("model");
      //(this.GetModelSelectList2);
    },
    handleSelectionChange(val) {
      val.forEach((item) => {
        this.TypeData.push(item);
      });
      let objs = {};
      this.TypeData = this.TypeData.reduce((datas, item) => {
        objs[item.id] ? "" : (objs[item.id] = true && datas.push(item));
        return datas;
      }, []);
      this.GetModelSelectList2.push(...val);
      var result = [];
      var obj = {};
      this.GetModelSelectList2.forEach((item) => {
        if (!obj[item.mosl01]) {
          result.push(item);
          obj[item.mosl01] = true;
        }
      });
      this.GetModelSelectList2 = result;
      this.pushModelIds();
    },
    // modelChooseList() {
    //   this.modelChooseListOpen = true;
    //   let params = {
    //     xid: localStorage.getItem("xid"),
    //     seachword: "",
    //     pageIndex: 1,
    //     pageSize: 1000,
    //   };
    //   GetProjectModelList({ params }).then((res) => {
    //     this.ModelList = res.Data.list;
    //     this.mid = res.Data.list[0].mode01;
    //     this.form.wkod14 = res.Data.list[0].mode01;
    //     this.modelName = res.Data.list[0].mode02;
    //     this.aa();
    //   });
    // },
    aa() {
      let params = {
        searchword: this.query2,
        mid: this.mid,
        type: this.TypeName,
        uid: localStorage.getItem("id"),
      };
      GetModelSelectOrViewPoint(params).then((res) => {
        this.GetModelSelectList = res.Data;
      });
    },
    // 切换模型
    handleClick(data) {
      this.wkod14 = data;
      this.mid = data;
      this.aa();
    },
    // 切换类型
    TypehandleClick(data) {
      // this.wkod14 = data;
      this.TypeName = data;
      this.aa();
    },
    associatedDataClose() {
      this.associatedData = false;
      this.multipleSelection2 = [];
      this.GetFilesLinksList2 = [];
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
      this.GetFilesLinksList2.push(...val);
      this.GetFilesLinksList2 = this.unique(this.GetFilesLinksList2, "file");
      this.pushModelIds();
    },
    unique(arr, type) {
      if (type == "model") {
        for (var i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].mosl01 == arr[j].mosl01) {
              //第一个等同于第二个，splice方法删除第二个
              arr.splice(j, 1);
              j--;
            }
          }
        }
      } else if (type == "file") {
        for (var i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].prfl01 == arr[j].prfl01) {
              //第一个等同于第二个，splice方法删除第二个
              arr.splice(j, 1);
              j--;
            }
          }
        }
      }
      return arr;
    },
    modelChooseListClose() {
      if (this.orderState) {
        this.modelChooseListOpen = false;
      } else {
        this.form.list = this.TypeData.length == 0 ? null : this.TypeData;
        let params = {
          wid: this.workOrderId,
          list: (this.form.list =
            this.TypeData.length == 0 ? null : this.TypeData),
        };
        AddModelLink(params).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: this.$t('common.处理成功'),
            });
          }
        });
      }
    },
    modelChooseListClose2() {
      this.TypeData = null;
      this.modelChooseListOpen = false;
    },
    handleNodeClick(data) {
      this.aaa.gid = data.ID;
      this.isClick = true;
      this.fid = data.ID;
      this.bb();
    },
    bb() {
      let params = {
        seachword: this.query3,
        fid: this.fid,
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
      };
      GetFilesLinks({ params }).then((res) => {
        this.GetFilesLinksList = res.Data;
      });
    },
    deletemultipleSelection(index) {
      this.GetModelSelectList2.splice(index, 1);
      this.pushModelIds("model");
    },
    deletemultipleSelection2(index) {
      this.GetFilesLinksList2.splice(index, 1);
      this.pushModelIds("file");
    },
    inputChange(data) {
      let params = {
        id: localStorage.getItem("xid"),
        cid: localStorage.getItem("pid"),
        uid: localStorage.id,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
        seachword: data,
      };
      GetUsersWithoutMe({ params }).then((res) => {
        this.userList = res.Data.list;
        this.total = res.Data.list.total;
      });
    },
  },
  created() {
    if (this.$route.params) {
      this.pitch = Number(this.$route.params.fl);
      this.pagesize = 100;
      this.getData(this.pitch);
    } else {
      this.getData(1);
    }
    this.getDataNum(3);
    this.getDataNum(2);
  },
  computed: {},
};
</script>

<style lang="less" scoped>
div#dataListRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#dataListRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#dataListRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#dataListRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

.userNamelist {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.enterpriseProject {
  // padding: 20px;
}

.search-input {
  width: 300px;
}

.search-input2 {
  width: 60%;
}

.el-main {
  padding: 0;
}

.contentuserlist {
  max-height: 580px;
  overflow-y: auto;
}

.page {
  padding: 5px 0;
  width: 100%;
  background-color: #d3dce6;
}

.textOverflow p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 60px;
}

#ProjectFileTree {
  height: 500px;
}

.zTreeDiv {
  overflow: auto;
}

.flexLr {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ztree li span {
  line-height: 21px;
  margin-right: 2px;
}

// /deep/.el-badge__content.is-fixed {
//   top: auto;
//   right: auto;
// }

/deep/ .warning-index {
  background: skyblue;
}
</style>
